import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import { CardContent } from '@/components/Card'

export interface OpenItemsProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onDocumentsReceived: () => unknown
  extensionActions?: ReactNode
}

export function OpenItemsProgressionActions({
  isAnyExtensionFlowAvailable,
  onDocumentsReceived,
  extensionActions,
}: OpenItemsProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Documents Received"
          variant="primary"
          size="wide-slim"
          onPress={onDocumentsReceived}
          testId="job-progression-set-job-started-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
